import React from 'react'
import { isEmpty } from 'lodash'

import { initTaskForProductInfo } from 'features/Ticket'
import {
  renderThumbnail,
  renderProductName,
  renderActions,
  renderProductInfo,
} from './renderProductsDescription'

import type { ITicketProductInfo } from 'features/Ticket/TicketProductInfo'
import type { ProductStructureProps } from './model'
import clsx from 'clsx'

const TicketProductStructure: React.FC<ProductStructureProps> = (props) => {
  const { product, ticketDetail, isLoading, onOpenHistoryModal } = props
  const base = 'f-ticket-product-info'

  const {
    id,
    name,
    photos = [],
    startWarranty,
    endWarranty,
    warrantyType,
    serialNumber,
    code,
  } = product

  let taskForProductInfo: ITicketProductInfo = initTaskForProductInfo
  let isCompleted = false

  if (!isEmpty(ticketDetail)) {
    taskForProductInfo = {
      ...ticketDetail,
      code,
      serialNumber,
    } as ITicketProductInfo
  }

  if (ticketDetail?.products) {
    const taskProduct = ticketDetail?.products.find(
      (item) => item.productId === product.id,
    )

    isCompleted = Boolean(taskProduct?.isCompleted)
  }

  return (
    <div className={`${base}__structure`}>
      {renderThumbnail(isLoading, photos)}

      <div className={`${base}__description`}>
        {renderProductName(isLoading, name)}

        <div
          className={clsx(
            `${base}__description--items-layout`,
            isLoading && `${base}__description--items-layout--loading`,
          )}
        >
          {renderActions(
            id,
            isLoading,
            isCompleted,
            startWarranty,
            endWarranty,
            warrantyType,
            onOpenHistoryModal,
          )}

          <div className={`${base}__product-info`}>
            {renderProductInfo(isLoading, taskForProductInfo)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketProductStructure
